import {
	helpCenterPublications,
	helpCenterPublicationsIntro,
} from "../data/helpCenterPublications";

const HelpCenterPublications = () => (
	<div className="help-center__content-block">
		<p className="help-center__page-intro fs-13 ff-light">
			{helpCenterPublicationsIntro}
		</p>
		<ul className="help-center__publications-list fs-13">
			{helpCenterPublications.map((pub) => (
				<li key={pub.href} className="help-center__publication-item">
					{pub.citation}{" "}
					<a
						href={pub.href}
						target="_blank"
						rel="noopener noreferrer"
						className="text-quat-de"
					>
						{pub.href}
					</a>
				</li>
			))}
		</ul>
	</div>
);

export default HelpCenterPublications;
